import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Research from "@/pages/Research";
import Enrich from "@/pages/Enrich";
import Lists from "@/pages/Lists";
import ListDetail from "@/pages/ListDetail";
import Profile from "@/pages/Profile";
import ChoosePlan from "@/pages/ChoosePlan";
import Billing from "@/pages/Billing";
import PaymentResult from "@/pages/PaymentResult";
import PlanRequired from "@/pages/PlanRequired";
import Admin from "@/pages/Admin";
import Welcome from "@/pages/Welcome";
import ExtensionUninstalled from "@/pages/ExtensionUninstalled";
import { Toaster } from "@/components/ui/sonner";

export default function App() {
  // Opens in the theme the person's computer uses; they can pick Light, Dark
  // or "Match my computer" from the workspace menu or Profile.
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <Navigate to="/research" replace />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/research"
              element={
                <ProtectedRoute>
                  <AppShell><Research /></AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/enrich"
              element={
                <ProtectedRoute>
                  <AppShell><Enrich /></AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/lists"
              element={
                <ProtectedRoute>
                  <AppShell><Lists /></AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/lists/:id"
              element={
                <ProtectedRoute>
                  <AppShell><ListDetail /></AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <AppShell><Profile /></AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/choose-plan"
              element={
                <ProtectedRoute allowLapsed>
                  <AppShell><ChoosePlan /></AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/billing"
              element={
                <ProtectedRoute allowLapsed>
                  <AppShell><Billing /></AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/billing/result"
              element={
                <ProtectedRoute allowLapsed>
                  <AppShell><PaymentResult /></AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/plan-required"
              element={
                <ProtectedRoute allowLapsed>
                  <AppShell><PlanRequired /></AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AppShell><Admin /></AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/welcome"
              element={
                <ProtectedRoute>
                  <AppShell><Welcome /></AppShell>
                </ProtectedRoute>
              }
            />
            {/* Public: Chrome opens it after the extension is removed. */}
            <Route path="/extension/uninstalled" element={<ExtensionUninstalled />} />
            <Route path="*" element={<Navigate to="/research" replace />} />
          </Routes>
          <Toaster richColors position="bottom-right" />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
